import { InputSwitch } from "primereact/inputswitch";
import { useContext } from "react";
import { ContainerScrollCommon } from "../../common/components/TableResponsive";

import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import AdminSideMenu from "../SideMenu/AdminSideMenu";
import UserSideMenu from "../SideMenu/UserSideMenu";
import User from "../User/User";
import {
  CurrencySwitch,
  ExchangeRate,
  MainButton,
  Sidebar,
  VersionDiv,
} from "./InitialLayoutStyles";
import { SessionTimer, useSessionTimer } from "./SessionTimer";

function AppSidebar({ isAdmin, userInfo, imageSrc, exchangeRate, onLogout }) {
  const full_name = userInfo.full_name;
  const agent_name = userInfo.agent.name;
  const [useDollars, updateUseDollars] = useContext<any>(CurrencyContext);
  useSessionTimer({ onLogout });
  return (
    <Sidebar>
      <ContainerScrollCommon boxShadow="#66667c99">
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            overflowY: "scroll",
            maxHeight: "100vh",
          }}
          className="scroll"
        >
          <div>
            <User
              agentName={agent_name}
              name={full_name}
              imageSrc={imageSrc}
              rol={userInfo.profile.name}
            />
            {isAdmin ? <AdminSideMenu /> : <UserSideMenu userInfo={userInfo} />}
          </div>
          <div className="sidebar-footer" style={{ marginBottom: "6rem" }}>
            <SessionTimer />
            <ExchangeRate>Tipo de cambio: S/ {exchangeRate}</ExchangeRate>
            <CurrencySwitch>
              <div className="switch-label">Cambiar a soles</div>
              <InputSwitch
                className="input-switch"
                checked={!useDollars}
                onChange={() => {
                  updateUseDollars(!useDollars);
                }}
              />
            </CurrencySwitch>
            <MainButton onClick={onLogout}>Cerrar sesión</MainButton>
            <VersionDiv>{(window as any).TALMACLICK_VERSION}</VersionDiv>
          </div>
        </div>
      </ContainerScrollCommon>
    </Sidebar>
  );
}

export default AppSidebar;
